<div class="banner-container" [ngClass]="{'success-container' : isSuccess, 'error-container' : !isSuccess }">
  <iris-icon
    *ngIf="isSuccess"
    class="banner-icon"
    name="check_circle"
    [color]="iconColors.SUCCESS"
  ></iris-icon>
  <iris-icon
    *ngIf="!isSuccess"
    class="banner-icon"
    name="error"
    [color]="iconColors.ERROR"
  ></iris-icon>
  <span class="text-description">
    <p 
      [ngClass]="{ 'remove-bottom-margin': isDescriptionEmpty }"
      class="header iris-button-text" 
      data-test="banner-title"
    >
      {{ message?.title }}
    </p>
    <p *ngIf="!isDescriptionEmpty" class="remove-bottom-margin" data-test="banner-description">{{ message?.description }}</p>
  </span>
</div>
